import { pregunta_url } from "./urlBase"
import { apiCall } from "./apiCall";

const listar_preguntas = async ( formato ) => {

    try {

        // const token = localStorage.getItem('token')
        // const request = client(token)
        // const resp = await request.call( 'GET', pregunta_url, null )

        const resp = await apiCall( 'GET', `${pregunta_url}/${formato}` , null )
        const response = resp.data

       // alert(response.data)

        if ( response.Success ) {
            return response
        }
        else {
            console.log('preguntasHelper', '15')
            throw response
        }

    } catch ( e ) {
        console.log('preguntasHelper', '20')
        throw e
    }
}

export {
    listar_preguntas
}